// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3AsxD","dragIcon":"Choice_dragIcon__XNj6I","left":"Choice_left__1D8AK","input":"Choice_input__38pan"};